<div class="flex flex-col">
    <ion-button
        *ngIf="isWebPurchaseAllowed"
        [attr.aria-label]="'ADD_MONEY' | translate"
        [disabled]="card?.blocked || card?.cardType === cardType.EMV"
        [fill]="mode === 'dialog' ? 'clear' : 'solid'"
        [ngClass]="{ 'mb-3': mode === 'default' }"
        [size]="mode === 'default' ? 'large' : 'default'"
        (click)="addMoneyClick.emit()"
        color="secondary">
        <ion-icon
            *ngIf="mode === 'default'"
            [ngClass]="{
                'dark:text-contrast-yellow': mode === 'dialog',
                'dark:text-contrast-black': mode === 'default'
            }"
            src="{{ assetsPath$ | async }}/img/cards/top-up.svg"></ion-icon>
        <ion-label
            class="normal-case"
            [ngClass]="{
                'font-semibold text-secondary dark:text-contrast-yellow': mode === 'dialog',
                'ml-2 text-base font-bold dark:text-contrast-black': mode === 'default'
            }"
            >{{ 'ADD_MONEY' | translate }}
        </ion-label>
    </ion-button>

    <ng-container *ngFor="let action of actions">
        <div class="box-border border-b border-solid border-black border-opacity-10 dark:border-contrast-yellow"></div>
        <div class="flex w-full" [ngClass]="{ 'md:w-auto': mode === 'default' }">
            <ion-button
                class="w-full"
                [attr.aria-label]="action.label | translate"
                [ngClass]="{ 'md:w-auto': mode === 'default' }"
                (click)="action.emitFunction.emit()"
                fill="clear">
                <ion-label
                    class="font-semibold normal-case dark:text-contrast-yellow"
                    [ngClass]="{
                        'text-secondary': action.actionType === 'normal',
                        'text-[#E31D17]': action.actionType === 'danger'
                    }"
                    >{{ action.label | translate }}</ion-label
                >
            </ion-button>
        </div>
    </ng-container>
</div>
